import { format, parseISO } from 'date-fns';

export const UtilConvertDateTodayDate = (dateString) => {
  // Parse the input date string
  const date = parseISO(dateString);
  
  // Format the date as desired
  return format(date, 'EEE, MMMM dd, yy');
}
